import { getCurrentLocale, localizeUrl } from '@/utils/localeRoute.js'

export default {
  mounted (el, ops) {
    el.addEventListener('click', (e) => {
      e.stopPropagation()
      const target = ops.value
      if (!target) {
        return
      }
      if (/^https?:\/\//.test(target)) {
        window.open(target, '_blank')
        return
      }
      const locale = getCurrentLocale({
        path: globalThis.$route?.path || window.location.pathname,
      })
      window.open(localizeUrl(target, locale), '_blank')
    })
  }
}
